import { Component, inject, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { LanguageService } from './core/i18n/language.service';
import { TranslocoService } from '@jsverse/transloco';
import { PrimeNGConfig } from 'primeng/api';
import { PRIME_NG_LOCALES } from './core/i18n/primeng-i18n';
import { AuthService } from './core/auth/auth.service';
import { Title } from '@angular/platform-browser';
import { take } from 'rxjs/operators';

@Component({
  standalone: true,
  imports: [RouterModule, ToastModule, ConfirmDialogModule],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    class: 'layout-app-container'
  }
})
export class AppComponent implements OnInit {

  private title = inject(Title);
  private auth = inject(AuthService);
  private primengConfig = inject(PrimeNGConfig);
  private languageService = inject(LanguageService);
  private translocoService = inject(TranslocoService);

  ngOnInit(): void {
    const lang = this.languageService.activeLang();
    this.applyPrimeNGLocale(lang);

    this.translocoService.langChanges$.subscribe((newLang) => {
      this.applyPrimeNGLocale(newLang);
    });

    this.auth
      .currentUser$
      .subscribe((user: any) => {
        user?.role === 'master_account' ?
          this.title.setTitle('СЗ Мастер Аккаунт')
          : this.title.setTitle('СЗ Business');
      });
  }

  private applyPrimeNGLocale(lang: string): void {
    const locale = PRIME_NG_LOCALES[lang] ?? PRIME_NG_LOCALES['ru'];
    this.primengConfig.setTranslation(locale);
  }
}
